import { render, staticRenderFns } from "./CorporateSync.vue?vue&type=template&id=b94864ca&scoped=true"
import script from "./CorporateSync.vue?vue&type=script&setup=true&lang=js"
export * from "./CorporateSync.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94864ca",
  null
  
)

export default component.exports